import React from "react";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import {BrowserRouter as Router , Switch, Route, Link} from 'react-router-dom';


import { Formik, Form } from "formik";
import * as yup from "yup";

let CliniciansSchema = yup.object().shape({
  ResidentId: yup.string().required("This field is required."),
  FirstName: yup.string().required("This field is required."),
  MiddleName: yup.string().required("This field is required."),
  LastName: yup.string().required("This field is required."),
  AddressLine1: yup.string().required("This field is required."),
  AddressLine2: yup.string().required("This field is required."),
  City: yup.string().required("This field is required."),
  State: yup.string().required("This field is required."),
  Zip: yup.string().required("This field is required."),
  Gender: yup.string().required("This field is required."),
  DOB: yup.string().required("This field is required."),
  Email: yup.string().required("This field is required."),
  Phone: yup.string().required("This field is required."),
});

const useStyles = makeStyles(theme => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white
    }
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    '& h2, h3, h4':{
      textAlign: 'left !important',
      color: '#999 !important',
    }
    
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  
}));

export const AdminCliniciansForm = () => {
  const classes = useStyles();

  return (
    <Container component="main" maxWidth="lg">
      <Link to={'/admin/clinicians'}  >
          <Button color="primary">Back to Clinicians Admin</Button>
      </Link>
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          Clinicians Form
        </Typography>
        <Formik
          initialValues={{
            firstName: "",
            lastName: "",
            email: "",
            password: ""
          }}
          validationSchema={CliniciansSchema}
          onSubmit={values => {
            console.log(values);
          }}
        >
          {({ errors, handleChange, touched }) => (
            <Form className={classes.form}>
              <Grid container spacing={2}>
              <Grid item xs={12}><h3>Identity</h3></Grid>
                
              <Grid item xs={12} sm={4}>
                  <TextField
                    error={errors.firstName && touched.firstName}
                    autoComplete="fname"
                    name="firstName"
                    variant="outlined"
                    fullWidth
                    onChange={handleChange}
                    id="firstName"
                    label="First Name"
                    autoFocus
                    helperText={
                      errors.firstName && touched.firstName
                        ? errors.firstName
                        : null
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    error={errors.MiddleName && touched.MiddleName}
                    autoComplete="mname"
                    name="MiddleName"
                    variant="outlined"
                    fullWidth
                    onChange={handleChange}
                    id="MiddleName"
                    label="Middle Name"
                    autoFocus
                    helperText={
                      errors.MiddleName && touched.MiddleName
                        ? errors.MiddleName
                        : null
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    error={errors.lastName && touched.lastName}
                    variant="outlined"
                    fullWidth
                    onChange={handleChange}
                    id="lastName"
                    label="Last Name"
                    name="lastName"
                    autoComplete="lname"
                    helperText={
                      errors.lastName && touched.lastName
                        ? errors.lastName
                        : null
                    }
                  />
                </Grid>
               
                <Grid item xs={12} sm={12} md={4}>
                  <TextField
                    error={errors.email && touched.email}
                    variant="outlined"
                    fullWidth
                    onChange={handleChange}
                    id="email"
                    label="Email Address"
                    name="email"
                    autoComplete="email"
                    helperText={
                      errors.email && touched.email ? errors.email : null
                    }
                  />
                </Grid>

                <Grid item xs={12}><h3>Clinical Info</h3></Grid>

                <Grid item xs={12} sm={4} md={3}>

                    <InputLabel id="demo-simple-select-label">Clinician Type</InputLabel>
                    <Select
                    variant="outlined"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="userstatus"
                    fullWidth
                    onChange={handleChange}
                    >
                    <MenuItem value={10}>MD</MenuItem>
                    <MenuItem value={10}>HN</MenuItem>
                    <MenuItem value={10}>MT</MenuItem>
                    <MenuItem value={10}>CNA</MenuItem>
                    
                    </Select>
                </Grid>


                <Grid item xs={12} sm={4} md={3}>
                  <TextField
                    error={errors.lastName && touched.lastName}
                    variant="outlined"
                    fullWidth
                    onChange={handleChange}
                    id="lastName"
                    label="Clinician ID"
                    name="lastName"
                    autoComplete="lname"
                    helperText={
                      errors.lastName && touched.lastName
                        ? errors.lastName
                        : null
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={4} md={3}>
                  <TextField
                    error={errors.lastName && touched.lastName}
                    variant="outlined"
                    fullWidth
                    onChange={handleChange}
                    id="lastName"
                    label="NPI"
                    name="lastName"
                    autoComplete="lname"
                    helperText={
                      errors.lastName && touched.lastName
                        ? errors.lastName
                        : null
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <TextField
                    error={errors.lastName && touched.lastName}
                    variant="outlined"
                    fullWidth
                    onChange={handleChange}
                    id="lastName"
                    label="DEA Number"
                    name="lastName"
                    autoComplete="lname"
                    helperText={
                      errors.lastName && touched.lastName
                        ? errors.lastName
                        : null
                    }
                  />
                </Grid>



              </Grid>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Submit
              </Button>
            </Form>
          )}
        </Formik>
      </div>
    </Container>
  );
};
